import { CanMatchFn } from '@angular/router';

const LOGIN_HOST_PREFIXES = ['portal', 'msp'];


/**
 * `/login` only matches on `portal…` / `msp…` hosts or local dev. Any other hostname
 * does not match the route (wildcard → home), same as an invalid path.
 */
export const legacyLoginGuard: CanMatchFn = () => {
  if (typeof window === 'undefined') {
    return true;
  }

  const host = window.location.hostname.toLowerCase();

  let allowLoginRoute = false;
  if (host === 'localhost' || host === '127.0.0.1') {
    allowLoginRoute = true;
  } else if (LOGIN_HOST_PREFIXES.some((prefix) => host.startsWith(prefix))) {
    allowLoginRoute = true;
  }

  return allowLoginRoute;
};
